<!-- Mobile: Foxera Drawer Full with Custom Header -->
@if (responsiveService.isMobileView()) {
  <foxera-drawer-full
    [(visible)]="drawerVisible"
    [title]="''"
    [fullSizeContainer]="true"
    [noPadding]="true"
    [showFooter]="false"
    [useCustomHeader]="true"
    (onClose)="onDone()">
    
    <!-- Custom Header -->
    <div customHeader class="px-4 pt-4 pb-3">
      @if (!isLoading() && workoutPlan()) {
        <!-- Day Tabs, Info Button, and Close Button - Single Row -->
        <div class="flex items-center  justify-between gap-3 mb-2.5">
          <!-- Left: Day Tabs -->
          <div class="flex-1 flex  justify-start items-center max-w-2xl scrollbar-hide  overflow-x-auto md:max-w-none ">
            <app-foxera-tabs-modern
              [tabs]="dayTabs()"
              [activeTab]="selectedDayTab()"
              (tabChange)="onDayTabChange($event)">
            </app-foxera-tabs-modern>
          </div>
          
          <!-- Right: Info Button and Close Button -->
          <div class="flex items-center gap-2 flex-shrink-0">
            <button
              (click)="showDetailsDrawer.set(true)"
              class="flex items-center justify-center gap-1.5 px-2.5 h-9 rounded-full bg-white/60 hover:bg-white border border-white transition-all duration-150 [-webkit-tap-highlight-color:transparent]"
              title="View Details">
              <span class="pi pi-info-circle text-primary-600 text-sm"></span>
              <span class="text-xs font-medium text-grey-700">{{ workoutInfo()?.fullName?.split(' ')?.[0] || 'Client' }}</span>
            </button>
            
            <button
              (click)="onDone()"
              class="flex items-center justify-center w-9 h-9 rounded-full bg-white/60 hover:bg-white border border-white transition-all duration-150 [-webkit-tap-highlight-color:transparent]">
              <span class="pi pi-times text-grey-600 text-base"></span>
            </button>
          </div>
        </div>
      } @else {
        <!-- Loading State - Close Button Only -->
        <div class="flex items-center justify-end mb-2.5">
          <button
            (click)="onDone()"
            class="flex items-center justify-center w-9 h-9 rounded-full bg-white/90 hover:bg-white border border-grey-200 transition-all duration-150 [-webkit-tap-highlight-color:transparent]">
            <span class="pi pi-times text-grey-600 text-base"></span>
          </button>
        </div>
      }
    </div>
    
    <!-- Content -->
    <ng-container *ngTemplateOutlet="planContent"></ng-container>
  </foxera-drawer-full>
  
  <!-- Fixed Footer Buttons (Mobile) - Outside Drawer -->
  @if (responsiveService.isMobileView() && workoutPlan() && !isLoading()) {
    <div class="fixed bottom-0 left-0 right-0 px-4 py-4 bg-white/40 border-t border-white z-[1105]" style="padding-bottom: env(safe-area-inset-bottom);">
      <div class="flex flex-col gap-3">
        <!-- Duplicate Error Message (Mobile) -->
        @if (duplicateErrorMessage()) {
          <div class="p-3 bg-red-50 border-2 border-red-500 rounded-xl flex items-start gap-2">
            <i class="pi pi-exclamation-triangle text-red-600 text-base mt-0.5"></i>
            <div class="flex-1">
              <h4 class="text-xs font-bold text-red-900 mb-1">Cannot Save Plan</h4>
              <p class="text-xs text-red-800">{{ duplicateErrorMessage() }}</p>
            </div>
            <button
              type="button"
              class="text-red-600 hover:text-red-800 cursor-pointer"
              (click)="clearDuplicateError()"
              title="Dismiss">
              <i class="pi pi-times text-sm"></i>
            </button>
          </div>
        }
        
        <!-- Reviewed Toggle & Reset Button Container -->
        <div class="flex items-center gap-2 transition-all duration-300">
          <!-- Reviewed Toggle -->
          <div [class]="hasChanges() 
            ? 'flex items-center justify-center gap-2 px-2.5 py-2 bg-white/80 rounded-lg border border-grey-200 flex-1 transition-all duration-300' 
            : 'flex items-center justify-center gap-2 px-2.5 py-2 bg-white/80 rounded-lg border border-grey-200 w-full transition-all duration-300'">
            <span class="text-xs text-grey-600 font-medium">Reviewed</span>
            <foxera-toggle-switch
              id="reviewStatus"
              name="reviewStatus"
              [(ngModel)]="isReviewed"
              class="toggle-green"
            />
          </div>
          
          <!-- Reset Button (appears with transition) -->
          @if (hasChanges()) {
            <button
              type="button"
              class="flex items-center gap-1.5 px-3 py-2 bg-white/80 hover:bg-grey-50 border border-grey-200 rounded-lg text-xs font-medium text-grey-600 hover:text-grey-800 transition-all duration-200 whitespace-nowrap animate-fade-in"
              (click)="onResetPlan()">
              <i class="pi pi-refresh text-[0.7rem] text-grey-600"></i>
              <span>Reset Plan</span>
            </button>
          }
        </div>
        
        <!-- Save Button -->
        <app-foxera-button
          [config]="{
            type: 'simple-save',
            severity: 'primary',
            size: 'large',
            normalText: 'Save Plan',
          }"
          [isLoading]="isSaving()"
          styleClass="!rounded-xl w-full"
          (buttonClick)="onSavePlan()">
        </app-foxera-button>
      </div>
    </div>
  }
  
  <!-- Client Details Drawer (Mobile) -->
  @if (!isLoading() && workoutPlan()) {
    <app-foxera-drawer-bottom 
      [(visible)]="showDetailsDrawer" 
      [title]="(workoutInfo()?.fullName || 'Client') + ' Details'"
      [showContentBackground]="false">
      <div class="flex flex-col gap-2">
        <!-- Goal -->
        @if (workoutPlan()!.clientDetails.goal) {
          <div class="px-4 py-3 bg-white/60 rounded-xl border-2 border-white">
            <app-plan-tags
              icon="pi pi-wave-pulse"
              label="Goal"
              [value]="workoutPlan()!.clientDetails.goal"
              type="default">
            </app-plan-tags>
          </div>
        }

        <!-- Athlete Sport -->
        @if (workoutPlan()!.clientDetails.athleteSport) {
          <div class="px-4 py-3 bg-white/60 rounded-xl border-2 border-white">
            <app-plan-tags
              icon="pi pi-trophy"
              label="Sport"
              [value]="workoutPlan()!.clientDetails.athleteSport!"
              type="default">
            </app-plan-tags>
          </div>
        }

        <!-- Level -->
        @if (workoutPlan()!.clientDetails.fitnessLevel) {
          <div class="px-4 py-3 bg-white/60 rounded-xl border-2 border-white">
            <app-plan-tags
              icon="pi pi-chart-line"
              label="Level"
              [value]="workoutPlan()!.clientDetails.fitnessLevel"
              type="default">
            </app-plan-tags>
          </div>
        }

        <!-- Health Notes -->
        @if (hasHealthNotes()) {
          <div class="px-4 py-3 bg-white/60 rounded-xl border-2 border-white">
            <app-plan-tags
              icon="⚠️"
              label="Health Notes"
              [value]="getHealthNotes()"
              type="pain"
              [showTag]="true">
            </app-plan-tags>
          </div>
        }

        <!-- Focus -->
        @if (workoutPlan()!.clientDetails.focusMuscles && workoutPlan()!.clientDetails.focusMuscles.length > 0) {
          <div class="px-4 py-3 bg-white/60 rounded-xl border-2 border-white">
            <app-plan-tags
              icon="pi pi-bullseye"
              label="Focus"
              [value]="workoutPlan()!.clientDetails.focusMuscles.join(', ')"
              type="focus"
              [showTag]="true">
            </app-plan-tags>
          </div>
        } @else {
          <div class="px-4 py-3 bg-white/60 rounded-xl border-2 border-white">
            <app-plan-tags
              icon="🎯"
              label="Focus"
              value="Full Body"
              type="focus"
              [showTag]="true">
            </app-plan-tags>
          </div>
        }

        <!-- Boxing -->
        @if (workoutPlan()!.clientDetails.boxing) {
          <div class="px-4 py-3 bg-white/60 rounded-xl border-2 border-white">
            <app-plan-tags
              icon="🥊"
              label="Boxing"
              [value]="workoutPlan()!.clientDetails.boxing"
              type="default">
            </app-plan-tags>
          </div>
        }
      </div>
    </app-foxera-drawer-bottom>
  }
  
  <!-- AI Notes Drawer (Mobile) -->
  @if (!isLoading() && workoutPlan() && getSelectedDay()) {
    <app-foxera-drawer-bottom 
      [(visible)]="showAiNotesDrawer" 
      [title]="'AI Notes - Day ' + getSelectedDay()!.day"
      [showContentBackground]="false">
      <div class="flex flex-col gap-3">
        <!-- Pain Considerations -->
        @if (getSelectedDay()!.painConsiderations) {
          <div class="px-4 py-3 bg-white/60 rounded-xl border-2 border-white border-l-4 border-l-orange-400">
            <div class="flex items-center gap-2 mb-2">
              <i class="pi pi-exclamation-triangle text-orange-500 text-base"></i>
              <h4 class="text-sm font-bold text-grey-900">Pain Considerations</h4>
            </div>
            <p class="text-sm text-grey-700 leading-relaxed whitespace-pre-line">
              {{ getSelectedDay()!.painConsiderations }}
            </p>
          </div>
        }

        <!-- Posture Recommendations -->
        @if (getSelectedDay()!.postureRecommendations) {
          <div class="px-4 py-3 bg-white/60 rounded-xl border-2 border-white border-l-4 border-l-blue-400">
            <div class="flex items-center gap-2 mb-2">
              <i class="pi pi-user text-blue-500 text-base"></i>
              <h4 class="text-sm font-bold text-grey-900">Posture Recommendations</h4>
            </div>
            <p class="text-sm text-grey-700 leading-relaxed whitespace-pre-line">
              {{ getSelectedDay()!.postureRecommendations }}
            </p>
          </div>
        }

        <!-- Session Notes -->
        @if (getSelectedDay()!.sessionNotes) {
          <div class="px-4 py-3 bg-white/60 rounded-xl border-2 border-white border-l-4 border-l-primary-400">
            <div class="flex items-center gap-2 mb-2">
              <i class="pi pi-bolt text-primary-500 text-base"></i>
              <h4 class="text-sm font-bold text-grey-900">Session Notes</h4>
            </div>
            <p class="text-sm text-grey-700 leading-relaxed whitespace-pre-line">
              @for (part of getSessionNoteParts(getSelectedDay()!.sessionNotes); track $index) {
                @if (part.highlight) {
                  <span [ngClass]="getSessionNoteHighlightClass(part.highlight)">{{ part.text }}</span>
                } @else {
                  {{ part.text }}
                }
              }
            </p>
          </div>
        }

        <!-- Sport Pattern Recommendations -->
        @if (getSelectedDay()!.sportPatternRecommendations) {
          <div class="px-4 py-3 bg-white/60 rounded-xl border-2 border-white border-l-4 border-l-orange-400">
            <div class="flex items-center gap-2 mb-2">
              <i class="pi pi-trophy text-orange-500 text-base"></i>
              <h4 class="text-sm font-bold text-grey-900">Sport Pattern Recommendations</h4>
            </div>
            <p class="text-sm text-grey-700 leading-relaxed whitespace-pre-line">
              {{ getSelectedDay()!.sportPatternRecommendations }}
            </p>
          </div>
        }

        <!-- Exercise Sequencing Strategy -->
        @if (getSelectedDay()!.exerciseSequencingStrategy) {
          <div class="px-4 py-3 bg-white/60 rounded-xl border-2 border-white border-l-4 border-l-green-400">
            <div class="flex items-center gap-2 mb-2">
              <i class="pi pi-list text-green-500 text-base"></i>
              <h4 class="text-sm font-bold text-grey-900">Exercise Sequencing Strategy</h4>
            </div>
            <p class="text-sm text-grey-700 leading-relaxed whitespace-pre-line">
              {{ getSelectedDay()!.exerciseSequencingStrategy }}
            </p>
          </div>
        }
      </div>
    </app-foxera-drawer-bottom>
  }
}

<!-- Desktop: Original Full Screen Modal -->
@if (!responsiveService.isMobileView()) {
  <div class="fixed inset-0 z-[1000] bg-white w-screen h-screen overflow-hidden animate-fade-in" >
    <div class="w-full h-full p-4 animate-scale-in" style="background: var(--Gradiant-background);">
      <div class="w-full h-full bg-white rounded-[2rem] flex flex-col relative shadow-lg animate-scale-in">
        <ng-container *ngTemplateOutlet="planContent"></ng-container>
      </div>
    </div>
  </div>
}

<!-- Shared Plan Content Template -->
<ng-template #planContent>
  <!-- Loading State -->
  @if (isLoading()) {
    @if(this.planId){
      <div class="flex items-center justify-center h-full w-full">
        <app-global-loading
          [loadingText]="'Loading workout plan...'"
          [isLoading]="isLoading()">
        </app-global-loading>
      </div>
    }
    @else{
      <!-- Wrap in Foxera Drawer Full -->
      <foxera-drawer-full
        [visible]="isLoading()"
        [title]="''"
        [showFooter]="false"
        [fullSizeContainer]="true"
        [noPadding]="true"
        [useCustomHeader]="true"
        [fullScreen]="true">
        
        <app-live-generation-plan-loading
          [workoutInfo]="workoutInfo()"
          [isLoading]="isLoading()"
          [jobId]="activeJobId"
          (stopGeneration)="onClose()"
          (hideInBackground)="onHideInBackground()">
        </app-live-generation-plan-loading>
      </foxera-drawer-full>
    }
  }

  @if (!isLoading() && workoutPlan()) {
          <!-- Compact Header Section (Desktop Only) -->
          @if (!responsiveService.isMobileView()) {
            <div class="flex-shrink-0 px-8 py-4 select-none border-b border-grey-100">
              <div class="flex items-center justify-between gap-4">
                <!-- Center: Day Tabs -->
                <div class="flex min-w-95 items-center justify-start">
                  <app-foxera-tabs-modern
                    [tabs]="dayTabs()"
                    [activeTab]="selectedDayTab()"
                    (tabChange)="onDayTabChange($event)">
                  </app-foxera-tabs-modern>
                </div>

                <!-- Right: Client Details Tags -->
                <div class="flex flex-wrap items-center gap-2 justify-end">
                  @if (workoutPlan()!.clientDetails.goal) {
                    <app-plan-tags
                      icon="pi pi-bullseye"
                      label="Goal"
                      [value]="workoutPlan()!.clientDetails.goal"
                      type="default">
                    </app-plan-tags>
                  }

                  @if (workoutPlan()!.clientDetails.athleteSport) {
                    <app-plan-tags
                      icon="pi pi-trophy"
                      label="Sport"
                      [value]="workoutPlan()!.clientDetails.athleteSport!"
                      type="default">
                    </app-plan-tags>
                  }

                  @if (workoutPlan()!.clientDetails.fitnessLevel) {
                    <app-plan-tags
                      icon="pi pi-chart-line"
                      label="Level"
                      [value]="workoutPlan()!.clientDetails.fitnessLevel"
                      type="default">
                    </app-plan-tags>
                  }

                  @if (hasHealthNotes()) {
                    <app-plan-tags
                      icon="⚠️"
                      label="Health Notes"
                      [value]="getHealthNotes()"
                      type="pain"
                      [showTag]="true">
                    </app-plan-tags>
                  }

                  @if (workoutPlan()!.clientDetails.focusMuscles && workoutPlan()!.clientDetails.focusMuscles.length > 0) {
                    <app-plan-tags
                      icon="pi pi-bullseye"
                      label="Focus"
                      [value]="workoutPlan()!.clientDetails.focusMuscles.join(', ')"
                      type="focus"
                      [showTag]="true">
                    </app-plan-tags>
                  } @else {
                    <app-plan-tags
                      icon="🎯"
                      label="Focus"
                      value="Full Body"
                      type="focus"
                      [showTag]="true">
                    </app-plan-tags>
                  }

                  @if (workoutPlan()!.clientDetails.boxing) {
                    <app-plan-tags
                      icon="🥊"
                      label="Boxing"
                      [value]="workoutPlan()!.clientDetails.boxing"
                      type="default">
                    </app-plan-tags>
                  }
                </div>
              </div>
            </div>
          }

          <!-- Content Area - Fully Scrollable -->
          <div class="flex-1 overflow-y-auto select-none" [class.pb-25]="responsiveService.isMobileView()">
            @if (getSelectedDay()) {
              <div class="space-y-0">
                <!-- Day Overview Card (Scrollable with content) -->
                <div class="px-1 md:px-8 py-3 md:py-4">
                  <div class="bg-gradient-to-r from-primary-50 via-primary-100 to-primary-50 rounded-xl px-4 md:px-5 py-3 md:py-4 border border-primary-200 shadow-sm">
                    <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 md:gap-6">
                      <!-- Left: Day Badge & Title -->
                      <div class="flex items-center gap-3">
                        <div class="flex items-center justify-center w-10 h-10 bg-white rounded-lg shadow-sm border border-primary-200">
                          <span class="text-sm font-bold text-primary-600">{{ getSelectedDay()!.day }}</span>
                        </div>
                        <div>
                        <button
                          type="button"
                          (click)="onEditDayTitle(getSelectedDay()!.day, getSelectedDay()!.title)"
                          class="flex items-center gap-2 cursor-pointer px-2 md:px-3 py-1 md:py-1.5 bg-grey-50/30 rounded-lg hover:bg-grey-100/50 transition-colors border border-grey-200/50"
                          title="Click to edit">
                          <h2 class="text-base md:text-lg font-bold text-grey-900">
                            {{ getSelectedDay()!.title }}
                          </h2>
                          <i class="pi pi-pencil text-xs text-grey-400"></i>
                        </button>
                          <div class="flex items-center gap-2 md:gap-3 mt-1">
                            <span class="flex items-center gap-1.5 text-xs text-grey-600">
                              <i class="pi pi-clock text-primary-500"></i>
                              {{ getFormattedTotalTime() }}
                            </span>
                            <span class="flex items-center gap-1.5 text-xs text-grey-600">
                              <i class="pi pi-list text-primary-500"></i>
                              {{ getTotalExercises(getSelectedDay()!.structure) }} exercises
                            </span>
                            <!-- AI Notes Button -->
                            <button 
                              type="button"
                              class="flex items-center cursor-pointer gap-1 text-xs text-primary-600 hover:text-primary-800 font-medium transition-colors"
                              (click)="responsiveService.isMobileView() ? showAiNotesDrawer.set(true) : aiNotesPopover.toggle($event)">
                              <i class="pi pi-info-circle"></i>
                              <span>AI Notes</span>
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- Right: Muscle Tags -->
                      <div class="flex flex-wrap items-start md:items-center gap-1.5 justify-start md:justify-end max-w-2xl">
                        @for (muscle of getSelectedDay()!.targetedMuscles; track muscle) {
                          <span class="inline-flex items-center px-2.5 py-1 bg-white text-primary-800 rounded-md text-xs font-medium border border-primary-200">
                            {{ muscle }}
                          </span>
                        }
                      </div>
                    </div>

                    <!-- Popover for AI Notes -->
                    <p-popover #aiNotesPopover [style]="{ width: '500px' }">
                      <div class="p-5 space-y-4 max-h-96 overflow-y-auto">
                        <!-- Pain Considerations -->
                        @if (getSelectedDay()!.painConsiderations) {
                          <div class="border-l-3 border-orange-400 pl-4">
                            <div class="flex items-center gap-2 mb-2">
                              <i class="pi pi-exclamation-triangle text-orange-500"></i>
                              <h4 class="text-sm font-bold text-grey-900">Pain Considerations</h4>
                            </div>
                            <p class="text-xs text-grey-700 leading-relaxed whitespace-pre-line">
                              {{ getSelectedDay()!.painConsiderations }}
                            </p>
                          </div>
                        }

                        <!-- Posture Recommendations -->
                        @if (getSelectedDay()!.postureRecommendations) {
                          <div class="border-l-3 border-blue-400 pl-4">
                            <div class="flex items-center gap-2 mb-2">
                              <i class="pi pi-user text-blue-500"></i>
                              <h4 class="text-sm font-bold text-grey-900">Posture Recommendations</h4>
                            </div>
                            <p class="text-xs text-grey-700 leading-relaxed whitespace-pre-line">
                              {{ getSelectedDay()!.postureRecommendations }}
                            </p>
                          </div>
                        }

                        <!-- Session Notes -->
                        @if (getSelectedDay()!.sessionNotes) {
                          <div class="border-l-3 border-primary-400 pl-4">
                            <div class="flex items-center gap-2 mb-2">
                              <i class="pi pi-bolt text-primary-500"></i>
                              <h4 class="text-sm font-bold text-grey-900">Session Notes</h4>
                            </div>
                            <p class="text-xs text-grey-700 leading-relaxed whitespace-pre-line">
                              @for (part of getSessionNoteParts(getSelectedDay()!.sessionNotes); track $index) {
                                @if (part.highlight) {
                                  <span [ngClass]="getSessionNoteHighlightClass(part.highlight)">{{ part.text }}</span>
                                } @else {
                                  {{ part.text }}
                                }
                              }
                            </p>
                          </div>
                        }

                        <!-- Sport Pattern Recommendations -->
                        @if (getSelectedDay()!.sportPatternRecommendations) {
                          <div class="border-l-3 border-orange-400 pl-4">
                            <div class="flex items-center gap-2 mb-2">
                              <i class="pi pi-trophy text-orange-500"></i>
                              <h4 class="text-sm font-bold text-grey-900">Sport Pattern Recommendations</h4>
                            </div>
                            <p class="text-xs text-grey-700 leading-relaxed whitespace-pre-line">
                              {{ getSelectedDay()!.sportPatternRecommendations }}
                            </p>
                          </div>
                        }

                        <!-- Exercise Sequencing Strategy -->
                        @if (getSelectedDay()!.exerciseSequencingStrategy) {
                          <div class="border-l-3 border-green-400 pl-4">
                            <div class="flex items-center gap-2 mb-2">
                              <i class="pi pi-list text-green-500"></i>
                              <h4 class="text-sm font-bold text-grey-900">Exercise Sequencing Strategy</h4>
                            </div>
                            <p class="text-xs text-grey-700 leading-relaxed whitespace-pre-line">
                              {{ getSelectedDay()!.exerciseSequencingStrategy }}
                            </p>
                          </div>
                        }
                      </div>
                    </p-popover>
                  </div>
                </div>

                <!-- Exercise Sections -->
                <div class="px-1 md:px-8 pb-6">
                <div class="space-y-5">
                @for (section of getSelectedDay()!.structure; track section.title; let i = $index) {
                  <div class="group relative">
                    <!-- Creative Section Card -->
                    <div class="relative bg-white border border-gray-200 rounded-2xl overflow-hidden transition-all duration-300">
                      

                      <!-- Section Header with Icon Badge -->
                      <div class="flex items-center justify-between px-3 md:px-6 py-2 md:py-2.5 border-b border-grey-100"
                           [ngClass]="{'cursor-pointer hover:bg-orange-50/30 transition-colors': getSectionClass(section.title) === 'warmup'}"
                           (click)="getSectionClass(section.title) === 'warmup' ? toggleSectionExpansion(section.title) : null">
                        <div class="flex items-center gap-2 md:gap-2.5 flex-1 min-w-0">
                          <!-- Icon Badge -->
                          <div 
                            class="flex items-center justify-center w-7 h-7 md:w-8 md:h-8 rounded-lg flex-shrink-0"
                            [ngClass]="{
                              'bg-orange-100': getSectionClass(section.title) === 'warmup',
                              'bg-primary-100': getSectionClass(section.title) === 'resistance-training',
                              'bg-red-100': getSectionClass(section.title) === 'cardio',
                              'bg-blue-100': getSectionClass(section.title) === 'cooldown'
                            }">
                            <i 
                              class="pi text-xs md:text-sm"
                              [ngClass]="{
                                'pi-sun text-orange-600': getSectionClass(section.title) === 'warmup',
                                'pi-bolt text-primary-600': getSectionClass(section.title) === 'resistance-training',
                                'pi-heart text-red-600': getSectionClass(section.title) === 'cardio',
                                'pi-moon text-blue-600': getSectionClass(section.title) === 'cooldown'
                              }"></i>
                          </div>
                          
                          <!-- Title and Exercise Count -->
                          <div class="flex flex-col md:flex-row md:items-center gap-0 md:gap-2 min-w-0 flex-1">
                            <div class="flex items-center gap-1.5">
                              <h3 
                                class="text-sm md:text-sm font-bold truncate"
                                [ngClass]="{
                                  'text-orange-700': getSectionClass(section.title) === 'warmup',
                                  'text-primary-600': getSectionClass(section.title) === 'resistance-training',
                                  'text-red-700': getSectionClass(section.title) === 'cardio',
                                  'text-blue-700': getSectionClass(section.title) === 'cooldown'
                                }">
                                {{ section.title }}
                              </h3>
                              <!-- Inline chevron for warmup (rotates on toggle) -->
                              @if (getSectionClass(section.title) === 'warmup') {
                                <i class="pi pi-chevron-down text-[0.7rem] text-orange-500 transition-transform duration-300"
                                   [ngClass]="{'rotate-180': isSectionExpanded(section.title)}"></i>
                              }
                            </div>
                            <span class="text-[0.65rem] md:text-xs text-grey-500 md:before:content-['•'] md:before:mr-2">{{ section.exercises.length }} exercises</span>
                          </div>
                        </div>
                        
                        <div class="flex items-center gap-1.5 md:gap-2 flex-shrink-0" (click)="$event.stopPropagation()">
                          <!-- Add Exercise Button - Hidden for cooldown -->
                          @if (getSectionClass(section.title) !== 'cooldown') {
                          <button
                            type="button"
                            class="flex cursor-pointer border border-1 items-center gap-1 md:gap-1.5 px-2 md:px-3 py-1 md:py-1.5 rounded-lg text-[0.65rem] md:text-xs font-medium transition-all duration-200"
                            [ngClass]="{
                              'bg-orange-50 text-orange-700 hover:bg-orange-100  border-orange-200': getSectionClass(section.title) === 'warmup',
                              'bg-primary-50 text-primary-600 hover:bg-primary-100  border-primary-200': getSectionClass(section.title) === 'resistance-training',
                              'bg-red-50 text-red-700 hover:bg-red-100  border-red-200': getSectionClass(section.title) === 'cardio',
                              'bg-blue-50 text-blue-700 hover:bg-blue-100  border-blue-200': getSectionClass(section.title) === 'cooldown'
                            }"
                            (click)="onAddExercise(section.title)"
                            title="Add exercise to this section"
                          >
                            <i class="pi pi-plus text-[0.6rem] md:text-[0.65rem]"></i>
                            <span class="hidden md:inline">Add Exercise</span>
                            <span class="md:hidden">Add</span>
                          </button>
                          }

                          <!-- Duration Badge -->
                          @if (isSectionDurationEditable(section.title)) {
                            <button
                              type="button"
                              class="flex cursor-pointer items-center gap-1 md:gap-1.5 px-2 md:px-2.5 py-1 rounded-lg font-semibold text-[0.65rem] md:text-xs transition-all border"
                              [ngClass]="{
                                'bg-orange-50/50 text-orange-700 border-orange-200 hover:bg-orange-100/70': getSectionClass(section.title) === 'warmup',
                                'bg-red-50/50 text-red-700 border-red-200 hover:bg-red-100/70': getSectionClass(section.title) === 'cardio',
                                'bg-blue-50/50 text-blue-700 border-blue-200 hover:bg-blue-100/70': getSectionClass(section.title) === 'cooldown'
                              }"
                              (click)="onEditSectionDuration(getSelectedDay()!.day, section.title, getSectionDuration(section))"
                              title="Click to edit duration">
                              <i class="pi pi-clock text-[0.55rem] md:text-[0.65rem]"></i>
                              {{ getSectionDuration(section) }}<span class="inline"> min</span>
                              <i class="pi pi-pencil text-[0.3rem] md:text-[0.5rem]"></i>
                            </button>
                          } @else {
                            <div 
                              class="flex items-center gap-1 md:gap-1.5 px-2 md:px-2.5 py-1 rounded-lg font-semibold text-[0.65rem] md:text-xs"
                              [ngClass]="{
                                'bg-primary-50 text-primary-600': getSectionClass(section.title) === 'resistance-training',
                                'bg-orange-50 text-orange-700': getSectionClass(section.title) === 'warmup',
                                'bg-red-50 text-red-700': getSectionClass(section.title) === 'cardio',
                                'bg-blue-50 text-blue-700': getSectionClass(section.title) === 'cooldown'
                              }">
                              <i class="pi pi-clock text-[0.55rem] md:text-[0.65rem]"></i>
                              {{ getSectionDuration(section) }} <span class="inline">min</span>
                            </div>
                          }
                        </div>
                      </div>
                      
                      <!-- Exercise Cards - Grid Layout (Hidden for cooldown, or warmup when collapsed) -->
                      @if (getSectionClass(section.title) !== 'cooldown' && 
                           (getSectionClass(section.title) !== 'warmup' || isSectionExpanded(section.title))) {
                      <div class="relative px-6 py-5">
                        <div
                          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4"
                          cdkDropList
                          cdkDropListOrientation="mixed"
                          [cdkDropListData]="section.exercises"
                          (cdkDropListDropped)="onExerciseDropped($event, section.title)"
                        >
                          @for (exercise of section.exercises; track exerciseIndex; let exerciseIndex = $index) {
                            <div 
                              class="group/card exercise-drag-item"
                              cdkDrag
                              [cdkDragStartDelay]="{ touch: 1000, mouse: 0 }"
                              [style.animation-delay.ms]="exerciseIndex * 50"
                              (touchstart)="onTouchStart($event)"
                              (touchmove)="onTouchMove($event)"
                              (touchend)="onTouchEnd($event)"
                              (contextmenu)="onContextMenu($event)"
                              >
                              
                              <!-- Custom Drag Preview -->
                              <div class="exercise-drag-preview" *cdkDragPreview>
                                <div class="relative h-full bg-white/95 backdrop-blur-sm rounded-xl border-2 border-primary-400 overflow-hidden scale-95">
                                  <div class="relative w-full h-32 overflow-hidden bg-grey-200">
                                    @if (exercise.imagePath) {
                                      <img [src]="exercise.imagePath" [alt]="exercise.exerciseName" class="w-full h-full object-cover" />
                                    } @else {
                                      <div class="w-full h-full flex items-center justify-center">
                                        <i class="pi pi-image text-grey-400 text-2xl"></i>
                                      </div>
                                    }
                                  </div>
                                  <div class="p-3">
                                    <h4 class="text-xs font-bold text-grey-900 line-clamp-1">
                                      {{ exercise.exerciseName }}
                                    </h4>
                                  </div>
                                </div>
                              </div>

                              <!-- Placeholder (shown where item was originally) -->
                              <div 
                                class="bg-gradient-to-br from-primary-50 to-primary-100 border-2 border-dashed border-primary-400 rounded-xl min-h-[104px] md:min-h-[300px] opacity-60 transition-all duration-300 flex items-center justify-center"
                                *cdkDragPlaceholder>
                                <div class="flex flex-col items-center gap-2 text-primary-600">
                                  <i class="pi pi-arrows-alt text-2xl"></i>
                                  <span class="text-sm font-medium hidden md:block">Drop here</span>
                                </div>
                              </div>

                              <!-- Desktop: Vertical Card Layout -->
                              <div 
                                class="hidden md:block relative h-full bg-gradient-to-br from-grey-50 to-white rounded-xl border-2 border-grey-100 overflow-hidden transition-all duration-300 hover:border-primary-300 hover:shadow-lg cursor-pointer"
                                [ngClass]="{ 'exercise-duplicate-error': isDuplicateExercise(exercise.id, section.title) }"
                                (click)="onExerciseClick(exercise, section.title, exerciseIndex)">

                                <!-- Actions Button (Top Left) -->
                                <button
                                  type="button"
                                  class="absolute cursor-pointer top-2 left-2 z-20 w-7 h-7 rounded-md bg-white/90 backdrop-blur-sm border border-grey-200 flex items-center justify-center text-grey-700 hover:text-grey-900 hover:border-grey-300 hover:bg-white "
                                  (click)="openExerciseActions($event, section.title, exercise.id, exerciseIndex)"
                                  title="Exercise actions"
                                >
                                  <i class="pi pi-ellipsis-v text-[0.75rem]"></i>
                                </button>

                                <!-- Image with Overlay -->
                                <div class="relative w-full h-40 overflow-hidden bg-grey-200">
                                  @if (exercise.imagePath) {
                                    <img [src]="exercise.imagePath" [alt]="exercise.exerciseName" class="w-full h-full object-cover transition-transform duration-500" />
                                    <div class="absolute inset-0 bg-gradient-to-t from-primary-100/40 to-transparent opacity-100 "></div>
                                  } @else {
                                    <div class="w-full h-full flex items-center justify-center">
                                      <i class="pi pi-image text-grey-400 text-3xl"></i>
                                    </div>
                                  }
                                  
                                  <!-- Duration / Time-or-Reps Badge (Bottom Right) -->
                                  @if (isTimeOrRepsSection(section.title)) {
                                    @if (getExerciseTimeOrRepsText(exercise); as timeOrRepsText) {
                                      <div class="absolute bottom-2 right-2 flex items-center gap-1 px-2.5 py-1.5 rounded-full bg-gradient-to-br from-white/90 to-white/70 backdrop-blur-md border border-white/50 shadow-md">
                                        <span class="text-[0.65rem] font-semibold text-grey-800">{{ timeOrRepsText }}</span>
                                      </div>
                                    }
                                  } @else if (exercise.avgDuration && exercise.avgDuration > 0) {
                                    <div class="absolute bottom-2 right-2 flex items-center gap-1 px-2.5 py-1.5 rounded-full bg-gradient-to-br from-white/90 to-white/70 backdrop-blur-md border border-white/50 shadow-md">
                                      <span class="text-[0.65rem] font-semibold text-grey-800">{{ exercise.avgDuration }} min</span>
                                    </div>
                                  }
                                </div>

                                <!-- Content -->
                                <div class="p-4 space-y-3">
                                  <!-- Title & Level -->
                                  <div class="flex items-start justify-between gap-2">
                                    <h4 class="text-sm font-bold text-grey-900 line-clamp-1 leading-tight flex-1">
                                      {{ exercise.exerciseName }}
                                    </h4>
                                    <span 
                                      class="flex-shrink-0 px-2 py-0.5 rounded text-[0.6rem] font-medium uppercase tracking-wider"
                                      [ngClass]="{
                                        'border border-1 border-green-100 bg-green-50 text-green-950': exercise.level === 'Beginner',
                                        'border border-1 border-orange-200 bg-orange-100 text-orange-950': exercise.level === 'Intermediate',
                                        'border border-1 border-red-100 bg-red-50 text-red-950': exercise.level === 'Advanced'
                                      }">
                                      {{ exercise.level }}
                                    </span>
                                  </div>
                                  
                                  <!-- Muscles - Creative Pills -->
                                  <div class="flex flex-wrap gap-1.5">
                                    @for (muscle of exercise.muscles.slice(0, 2); track muscle; let muscleIdx = $index) {
                                        <span class="inline-flex items-center px-2.5 py-1 border border-grey-200 text-grey-700 rounded-full text-[0.65rem] font-semibold">
                                          {{ muscle }}
                                        </span>
                                    }
                                    @if (exercise.muscles.length > 2) {
                                      <span class="inline-flex items-center px-2.5 py-1 border border-grey-200 text-grey-700 rounded-full text-[0.65rem] font-semibold">
                                        +{{ exercise.muscles.length - 2 }}
                                      </span>
                                    }
                                  </div>

                                  <!-- Tags - If available -->
                                  @if (exercise.tags && exercise.tags.length > 0) {
                                    <div class="flex flex-wrap gap-1">
                                      @for (tag of exercise.tags.slice(0, 2); track tag) {
                                        <span 
                                          class="inline-flex items-center bg-gray-100 text-gray-600 px-2 py-1 rounded-md text-[0.6rem] font-bold"
                                          >
                                          ✦ {{ tag }}
                                        </span>
                                      }
                                      @if (exercise.tags.length > 2) {
                                        <span class="inline-flex items-center px-2.5 py-1 bg-gray-100 text-gray-600 rounded-md text-[0.6rem] font-bold">
                                          +{{ exercise.tags.length - 2 }}
                                        </span>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>

                              <!-- Mobile: Horizontal Card Layout -->
                              <div 
                                class="md:hidden flex items-center gap-3  border rounded-xl transition-all duration-300 bg-white hover:shadow-md cursor-pointer"
                                [ngClass]="{ 
                                  'border-grey-100 hover:border-primary-300': !isDuplicateExercise(exercise.id, section.title),
                                  'exercise-duplicate-error': isDuplicateExercise(exercise.id, section.title)
                                }"
                                (click)="onExerciseClick(exercise, section.title, exerciseIndex)">
                                
                                <!-- Exercise Thumbnail -->
                                <div class="flex-shrink-0 w-25 h-25 rounded-xl  overflow-hidden bg-gray-100  relative">
                                  @if (exercise.imagePath) {
                                    <img 
                                      [src]="exercise.imagePath" 
                                      [alt]="exercise.exerciseName"
                                      class="w-full h-full object-cover">
                                  } @else {
                                    <div class="w-full h-full flex items-center justify-center">
                                      <i class="pi pi-image text-grey-400 text-xl"></i>
                                    </div>
                                  }
                                  
                                 
                                </div>

                                <!-- Exercise Info -->
                                <div class="flex-1 min-w-0 py-2">
                                  <h4 class="font-semibold text-sm leading-tight truncate text-grey-900 mb-1.5">
                                    {{ exercise.exerciseName }}
                                  </h4>
                                  
                                  <!-- Tags - Mobile -->
                                  @if (exercise.tags && exercise.tags.length > 0) {
                                    <div class="flex flex-wrap gap-1">
                                      @for (tag of exercise.tags.slice(0, 2); track tag) {
                                        <span 
                                          class="inline-flex items-center bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded-md text-[0.6rem] font-bold"
                                          >
                                          ✦ {{ tag }}
                                        </span>
                                      }
                                      @if (exercise.tags.length > 2) {
                                        <span class="inline-flex items-center px-1.5 py-0.5 bg-gray-100 text-gray-600 rounded-md text-[0.6rem] font-bold">
                                          +{{ exercise.tags.length - 2 }}
                                        </span>
                                      }
                                    </div>
                                  }
                                </div>

                                <!-- Actions Button -->
                                <button
                                  type="button"
                                  class="flex-shrink-0 w-8 h-8 mr-4 rounded-md bg-white/90 backdrop-blur-sm border border-grey-200 flex items-center justify-center text-grey-700 hover:text-grey-900 hover:border-grey-300 hover:bg-white cursor-pointer"
                                  (click)="openExerciseActions($event, section.title, exercise.id, exerciseIndex)"
                                  title="Exercise actions"
                                >
                                  <i class="pi pi-ellipsis-v text-[0.75rem]"></i>
                                </button>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                }
                </div>
              </div>
              </div>
            }
          </div>

          <!-- Desktop Footer Section -->
          @if (!responsiveService.isMobileView()) {
            <div class="flex-shrink-0 px-8 py-5 border-t border-grey-100">
              <!-- Duplicate Error Message -->
              @if (duplicateErrorMessage()) {
                <div class="mb-4 p-4 bg-red-50 border-2 border-red-500 rounded-lg flex items-start gap-3">
                  <i class="pi pi-exclamation-triangle text-red-600 text-xl mt-0.5"></i>
                  <div class="flex-1">
                    <h4 class="text-sm font-bold text-red-900 mb-1">Cannot Save Plan</h4>
                    <p class="text-sm text-red-800">{{ duplicateErrorMessage() }}</p>
                  </div>
                  <button
                    type="button"
                    class="text-red-600 hover:text-red-800 cursor-pointer"
                    (click)="clearDuplicateError()"
                    title="Dismiss">
                    <i class="pi pi-times"></i>
                  </button>
                </div>
              }
              
              <div class="flex items-center justify-between">
                <!-- Left: Close Button -->
                <div class="flex items-center">
                  <p-button 
                    label="Close" 
                    icon="pi pi-times"
                    severity="secondary"
                    size="large"
                    [outlined]="true"
                    (click)="onDone()">
                  </p-button>
                </div>

                <!-- Right: Reset, Review Toggle, and Save Buttons -->
                <div class="flex items-center gap-3">
                  @if (hasChanges()) {
                    <p-button 
                      label="Reset to Original" 
                      icon="pi pi-refresh"
                      severity="secondary"
                      size="large"
                      [outlined]="true"
                      (click)="onResetPlan()">
                    </p-button>
                  }
                  
                  <!-- Review Status and Save - Unified Component -->
                  <div class="flex select-none items-center gap-3 px-4 py-2 bg-grey-50 rounded-lg border border-grey-200">
                    <!-- Review Status Toggle -->
                    <div class="flex items-center gap-2.5">
                      <span class="text-sm text-grey-700 select-none font-medium">Reviewed</span>
                      <foxera-toggle-switch
                        id="reviewStatus"
                        name="reviewStatus"
                        [(ngModel)]="isReviewed"
                        class="toggle-green"
                      />
                    </div>
                    
                    <!-- Divider -->
                    <div class="h-8 w-px bg-grey-300"></div>
                    
                    <!-- Save Button -->
                    <app-foxera-button
                      [config]="{
                        type: 'save',
                        severity: 'contrast',
                        size: 'small',
                        normalText: 'Save Plan',
                        loadingText: 'Saving...',
                        icon: 'pi pi-bookmark',
                        iconPos: 'left'
                      }"
                      [isLoading]="isSaving()"
                      (buttonClick)="onSavePlan()">
                    </app-foxera-button>
                  </div>
                </div>
              </div>
            </div>
          }
        }

        <!-- Empty State -->
        @if (!isLoading() && !workoutPlan()) {
          <div class="flex flex-col items-center justify-center h-full gap-4">
            <div class="w-20 h-20 rounded-full bg-grey-100 flex items-center justify-center">
              <i class="pi pi-inbox text-grey-400 text-3xl"></i>
            </div>
            <h2 class="text-xl font-semibold text-grey-800">No Workout Plan Available</h2>
            <p class="text-grey-500">Create a workout plan to get started with your training journey.</p>
            <p-button 
              label="Go Back" 
              icon="pi pi-arrow-left"
              (click)="onClose()">
            </p-button>
          </div>
        }
      </ng-template>

<!-- Exercise View Dialog -->
<!-- Exercise View Dialog -->
@if (isExerciseDialogVisible() && selectedExercise()) {
  <app-client-view-exercise
    [exerciseName]="selectedExercise()!.exerciseName"
    [animationPath]="selectedExercise()!.animationPath || ''"
    [level]="selectedExercise()!.level"
    [muscles]="selectedExercise()!.muscles"
    [tags]="selectedExercise()!.tags || []"
    [category]="selectedExercise()!.category"
    [avgDuration]="selectedExercise()!.avgDuration || 0"
    [isTimeOrRepsSection]="isTimeOrRepsSection(selectedExerciseContext()?.sectionTitle || '')"
    [isCardioSection]="getSectionClass(selectedExerciseContext()?.sectionTitle || '') === 'cardio'"
    [isTimeBased]="selectedExercise()!.isTimeBased ?? null"
    [totalTimeSec]="selectedExercise()!.totalTimeSec ?? null"
    [totalReps]="selectedExercise()!.totalReps ?? null"
    (close)="onExerciseDialogClose()"
    (totalTimeSecChanged)="onExerciseTotalTimeChanged($event)"
    (totalRepsChanged)="onExerciseTotalRepsChanged($event)">
  </app-client-view-exercise>
}

<!-- Exercise Search Dialog -->
@if (isSearchDialogVisible()) {
  <app-client-search-exercises
    [mode]="searchMode()"
    [sectionTitle]="selectedSectionForSearch() || undefined"
    [clientId]="clientId"
    [initialMovementPatterns]="selectedExerciseMovementPatterns()"
    [lockedBranchId]="planBranchId()"
    (close)="onSearchDialogClose()"
    (exercisesSelected)="onExercisesSelected($event)">
  </app-client-search-exercises>
}

<!-- Exercise Actions Popover (Desktop) -->
<p-popover #exerciseActionsPopover [dismissable]="true" [appendTo]="'body'">
  <ng-template #content>
    <div class="flex flex-col gap-1 p-2 min-w-[180px]">
      <button
        type="button"
        class="flex items-center gap-2 px-3 py-2 rounded-md hover:bg-grey-50 text-sm text-grey-900"
        (click)="onDeleteSelectedExercise()"
      >
        <i class="pi pi-trash text-red-600"></i>
        <span class="font-medium text-red-700">Delete</span>
      </button>

      <button
        type="button"
        class="flex items-center gap-2 px-3 py-2 rounded-md hover:bg-grey-50 text-sm text-grey-900 cursor-pointer"
        (click)="onSwitchExercisePlaceholder()"
      >
        <i class="pi pi-refresh text-primary-600"></i>
        <span class="font-medium">Switch exercise</span>
      </button>
    </div>
  </ng-template>
</p-popover>

<!-- Exercise Actions Drawer (Mobile) -->
@if (showExerciseActionsDrawer()) {
  <app-foxera-drawer-bottom 
    [(visible)]="showExerciseActionsDrawer" 
    title="Exercise Actions"
    [showContentBackground]="false">
    <div class="flex flex-col gap-2">
      <!-- Delete Button -->
      <button
        type="button"
        class="px-4 py-3 bg-white/60 rounded-xl border-2 border-white flex items-center gap-3 text-left hover:bg-white/80 transition-colors"
        (click)="onDeleteSelectedExercise()"
      >
        <i class="pi pi-trash text-red-600 text-lg"></i>
        <span class="font-medium text-red-700">Delete Exercise</span>
      </button>

      <!-- Switch Exercise Button -->
      <button
        type="button"
        class="px-4 py-3 bg-white/60 rounded-xl border-2 border-white flex items-center gap-3 text-left hover:bg-white/80 transition-colors"
        (click)="onSwitchExercisePlaceholder()"
      >
        <i class="pi pi-refresh text-primary-600 text-lg"></i>
        <span class="font-medium text-grey-900">Switch Exercise</span>
      </button>
    </div>
  </app-foxera-drawer-bottom>
}

<!-- Duration Edit Dialog -->
@if (isDurationDialogVisible()) {
  <app-foxera-edit-dialog
    [type]="'duration'"
    [sectionTitle]="editingSectionTitle()"
    [value]="tempDurationValue()"
    (save)="onSaveSectionDuration($event)"
    (close)="onCancelEditDuration()">
  </app-foxera-edit-dialog>
}

<!-- Day Title Edit Dialog -->
@if (isDayTitleDialogVisible()) {
  <app-foxera-edit-dialog
    [type]="'title'"
    [dayNumber]="editingDayNumber()"
    [value]="tempDayTitle()"
    (save)="onSaveDayTitle($event)"
    (close)="onCancelEditDayTitle()">
  </app-foxera-edit-dialog>
}
